<template>
  <div class="publish-wrap no-mobile">
    <button
      class="common-button button-publish-library main"
      @click.stop="toggleMenuOpen"
    >
      <svg
        class="add-icon"
        id="Component_105_1"
        data-name="Component 105 – 1"
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
      >
        <rect
          id="Rectangle_2617"
          data-name="Rectangle 2617"
          class="cls-1"
          width="3"
          height="22"
          rx="1.5"
          transform="translate(9.5)"
        />
        <rect
          id="Rectangle_2618"
          data-name="Rectangle 2618"
          class="cls-1"
          width="3"
          height="22"
          rx="1.5"
          transform="translate(22 9.5) rotate(90)"
        />
      </svg>
      <span class="text">
        {{ $t("PUBLISH_CONTENT") }}
      </span>
    </button>
    <div
      class="publish-dropdown publish-content"
      v-if="toggleBaseMenu === 'publish-options'"
    >
      <ul>
        <li
          @click.stop=""
          class="content"
          v-for="(publishOption, index) in publishOptions"
          :key="index"
        >
          <component :is="getTagName(publishOption)"
            @click="toggleAudioOptions"
            :to="{
              name: 'uploads',
              params: { type: publishOption.type },
            }"
            class="content-url"
          >
            <i class="icon">
              <img
                :src="getSrc(publishOption.icon)"
                :alt="publishOption.name"
              />
            </i>
            <span class="text">
              {{ getPublishOptionName(publishOption) }}
            </span>
          </component>
        </li>
      </ul>
      <div class="audio-options" v-if="isOpenAudioOptions">
        <ul class="audio-options-list">
          <li class="audio-options-item">
            <router-link
              :to="{
                name: 'uploads',
                params: { type: 'embedded-audio' },
              }">
              <img src="../assets/images/code.svg" alt="" class="icon">
              <span class="text">{{$t('EMBED_CODE')}}</span>
            </router-link>
          </li>
          <li class="audio-options-item">
            <router-link
              :to="{
                name: 'uploads',
                params: { type: 'audio' },
              }">
              <img src="../assets/images/upload-arrow.svg" alt="" class="icon">
              <span class="text">{{ $t('UPLOAD_FILE') }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { publishOptions } from '@/constants'
import { mapState, mapActions } from 'vuex'

export default {

  data () {
    return {
      isOpenAudioOptions: false
    }
  },

  computed: {
    ...mapState({
      toggleBaseMenu: state => state.base.toggleBaseMenu,
      direction: state => state.base.directionSystem,
      library: state => state.base.library
    }),
    publishOptions () {
      if (this.library.metadata.VIDEO_UPLOAD_ENABLED) {
        return publishOptions
      } else {
        return publishOptions.filter(option => option.type !== 'video')
      }
    }
  },
  methods: {
    ...mapActions(['toggleBaseLibraryMenu']),
    toggleAudioOptions (event) {
      // event.preventDefault()
      event.stopPropagation()
      this.isOpenAudioOptions = !this.isOpenAudioOptions
    },
    getTagName (publishOption) {
      // TODO: extract from comment, when it's possible to upload embedded-audio
      // if (publishOption.type === 'audio') {
      //   return 'button'
      // } else {
      return 'router-link'
      // }
    },
    getPublishOptionName (publishOption) {
      // If a Library doesn't have the option to upload video, display the Youtube Video option as just "video"
      if (publishOption.type === 'youtube' && !this.library.metadata.VIDEO_UPLOAD_ENABLED) {
        return this.$t('VIDEO')
      } else {
        return this.$t(publishOption.name)
      }
    },
    getSrc (imageName) {
      let image = null
      if (this.direction === 'ltr') {
        try {
          image = require('@/assets/images/' + imageName + '_ltr.svg')
        } catch {
          image = require('@/assets/images/' + imageName + '.svg')
        }
      } else {
        image = require('@/assets/images/' + imageName + '.svg')
      }
      return image
    },
    async toggleMenuOpen () {
      if (this.toggleBaseMenu === 'publish-options') {
        await this.$store.dispatch('toggleBaseLibraryMenu', null)
      } else {
        await this.$store.dispatch('toggleBaseLibraryMenu', 'publish-options')
      }
    }
  }
}
</script>
